import { UseQueryResult } from 'react-query';

export const DRAWER_ANIMATE_DURATION = 200;

export type DrawerSize = 'small' | 'medium' | 'large';

export interface DrawerProps {
  open: boolean;
  onClose: (force?: boolean) => void;
  onChange?: () => void;
  className?: string;
  query?: UseQueryResult;
  loading?: boolean;
  hideUpdateMenu?: boolean;
  isTopDrawer?: boolean;
  size?: DrawerSize;
  tab?: string;
}
